import { render, staticRenderFns } from "./UserPayroll.vue?vue&type=template&id=3c54a46e&scoped=true&"
import script from "./UserPayroll.vue?vue&type=script&lang=js&"
export * from "./UserPayroll.vue?vue&type=script&lang=js&"
import style0 from "./UserPayroll.vue?vue&type=style&index=0&id=3c54a46e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c54a46e",
  null
  
)

export default component.exports